import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/app/[locale]/jobs/[location]/[microRole]/[title]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/back-link/back-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/inputs/inline-search/inline-search.tsx");
